import React from 'react';
import { generatePath } from 'react-router-dom';
import Helper from '../../utility/helper';
import RouteConstants from '../../constants/routeConstants';
import { setTheme } from '../../hookState/ThemeState';
import DataList from '../../sharedcomponents/dataList/dataList';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
 
const AllEvents = (props) =>
{
    const redirectToEvent = (event) =>
    {
        ApiHelper.get(APIURLConstants.GET_EVENT(event.actualData.eventID, 0))
        .then((res) => {
            
            if(res.data){
                const path = generatePath(RouteConstants.EDIT_EVENT, {
                    eventID: event.actualData.eventID,
                });
                props.history.push({
                    pathname: path,
                    state: { event: res.data },
                });
            } 
        }) 
    };

    const redirectToCreate = () =>
    {
        props.history.push({
            pathname: RouteConstants.CREATE_EVENT,
            state: {},
        });
    };

    const handleEventClick = (event) =>
    {
        const actualData = event.actualData;
        setTheme(actualData);
        Helper.setStorage('eventInfo', actualData);
        const path = generatePath(RouteConstants.EVENT_DETAIL, { 'eventID': actualData.eventID });
        props.history.push({
            pathname: path,
            state: { event: actualData },
        });
    };

    return (
        <>
            {props.data && props.data.length > 0 ? (
                <DataList
                    data={props.data}
                    // onCheckSelect={props.onCheckSelect}
                    editRow={redirectToEvent}
                    handleClick={redirectToCreate}
                    title={'List Of Events'}
                    buttonTitle={'Add'}
                    deleteRows={props.deleteEvents}
                    showSearch={true}
                    searchLabel={'Search'}
                    viewPage={handleEventClick}
                    modPermission={props.modPermission}
                />
            )
                : null}
        </>
    );
};

export default AllEvents;
